import Vue from "vue";
import VueRouter from "vue-router";
import { getToken,removeToken} from '../util/auth'
import { getStore } from "@/util/store.js";
import { baseRouter } from './baseRouter'
import store from '../store/index'
Vue.use(VueRouter);
//重复跳转报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const routes = [...baseRouter];
const router = new VueRouter({
  base: '/',
  mode: 'history',
  routes:routes,
  scrollBehavior: () => ({ x: 0, y: 0 }),
});
router.beforeEach((to,from,next) => {
    if(to.meta.hidden || to.meta.hidden===undefined ){
      let type = getStore({ name: "userType" })
      if(type===1){
        let wshenAuth = getToken('Jst-SellerManager')
        if (wshenAuth == undefined || wshenAuth == "") {
          next('/login')
          return
        }
      }else{
          let wshenAuth = getToken('Jst-PlatformManager')
          if (wshenAuth == undefined || wshenAuth == "") {
            next('/login')
            return
          }
      }
      if(!store.getters.firstRoute&&to.name!=='KA入驻'&&to.name!=='供应商入驻'&&to.name!=='物流入驻'){
        store.dispatch("getRouter").then(routers => {
          routers.forEach(item => {
              router.addRoute(item)
          });
          next({...to,replace:true})
        })
      }
      let routerList = to.path.split('/')
      routerList.splice(0,1)
      let path = routerList.filter((item,index) => index<3).map(item => `/${item}`).join('')
      if(to.meta.parent){
        path = to.meta.parent
      }
      store.dispatch("setSelectedKeys",[path])

    }else{
      if (to.path === '/login') {
        // removeToken('Jst-SellerManager');
        // removeToken('Jst-PlatformManager');
        next();
      }
    }
  // }
  next();
})

export default router;
